import React, {useState, useEffect} from 'react';

import Loadable from '../ui/loading/Loadable.js';
import api from '../../api/index.js';

import SuperPieChart from './VarietySuperPieChart.js';
import BarChart from './BarChart.js';
import HarvestChart2 from './HarvestChart2.js';


export default (props) => {

	const [data, setData] = useState(false);
	const [harvestData, setHarvestData] = useState(false);
	const [selection, setSelection] = useState([null, null]);
	const [units, setUnits] = useState(false);


	useEffect(() => {
		refresh();
		refreshHarvests();
		if (units === false)
			refreshUnits();
	}, [props.dateStart, props.dateEnd]); // I didn't include farm and field here because they shouldn't actually ever change on the same page


	const refreshUnits = async () => {
		setUnits(await api.settings.get('display_units_mass'));
	}


	const refresh = async () => {
		try {
			let response = await api.get('dashboard/costs?from=' + props.dateStart.api() + '&until=' + props.dateEnd.api() + '&farm=' + (props.farm || '' ) + '&field=' + (props.field || ''));
			setData(response);
		} catch(e) {
			api.handleExceptions(e);
		};
	}
	const refreshHarvests = async () => {
		try {
			let response = await api.get('dashboard/harvest?from=' + props.dateStart.api() + '&until=' + props.dateEnd.api() + '&farm=' + (props.farm || '' ) + '&field=' + (props.field || ''));
			setHarvestData(response);
		} catch(e) {
			api.handleExceptions(e);
		};
	}


	const selectionchange = (crop, variety) => {
		setSelection([crop, variety]);
	}

	const [selectedCrop, selectedVariety] = selection;

	let costs = {};
	let unspecified = 0;
	if (data !== false) {
		for(let task in data['costs']['task_costs']) {
			if (!costs.hasOwnProperty(task))
				costs[task] = 0;
			for(let crop in data['costs']['task_costs'][task]) {
				if (selectedCrop === null || selectedCrop == crop) {
					for(let variety in data['costs']['task_costs'][task][crop]) {
						if (selectedVariety === null || selectedVariety == variety) {
							costs[task] += parseFloat(data['costs']['task_costs'][task][crop][variety]);
						if (selectedCrop === null && crop == 'Unspecified') // Across crops
							unspecified += parseFloat(data['costs']['task_costs'][task][crop][variety]);
						else if (selectedVariety === null && variety == 'Unspecified') // Crop specific
							unspecified += parseFloat(data['costs']['task_costs'][task][crop][variety]);
						}
					}
				}
			}
		}
	}
	
	let unspecified_identifer = 'crops';
	if (selectedCrop !== null)
		unspecified_identifer = 'variety'


	// Harvest totals
	let harvestgrouped = {};
	if (selectedCrop === null && selectedVariety === null) {
		// Group by crop
		for(let i=0; i < harvestData.length; i++) {
			if (!harvestgrouped.hasOwnProperty(harvestData[i]['CropName'])) {
				harvestgrouped[harvestData[i]['CropName']] = 0;
			}
			harvestgrouped[harvestData[i]['CropName']] += parseFloat(harvestData[i]['harvested']);
		}
	} else if (selectedCrop !== null) {
		for(let i=0; i < harvestData.length; i++) {
			if (harvestData[i]['CropName'] !== selectedCrop) continue;
			if (selectedVariety === null || selectedVariety == harvestData[i]['VarietyName']) {
				if (!harvestgrouped.hasOwnProperty(harvestData[i]['VarietyName'])) {
					harvestgrouped[harvestData[i]['VarietyName']] = 0;
				}
				harvestgrouped[harvestData[i]['VarietyName']] += parseFloat(harvestData[i]['harvested']);
			}
		}
		console.log("harvestgrouped", harvestgrouped);
	}
	

	return <>
		<div className="CostsChartGroup">
			<SuperPieChart width={800} height={800} data={data['crops'] || []} onSelectionChange={selectionchange} />
			<BarChart width={800} height={800} data={costs} />
		</div>
		<p>{selectedVariety === null && (<>${unspecified.moneyFormat()} not associated with any specific {unspecified_identifer}</>)}</p>
		<HarvestChart2 width={800} height={800} data={harvestgrouped} units={units} />
	</>;
}